import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import Step from './parts/Step';
import {Maybe} from '../utils/logging';
import _ from 'lodash';
import {setLanguageIndex} from '../utils/helpers';
import BathtubContent from './sidebar-menu/BathtubContent';
import DwdfContent from './sidebar-menu/DwdfContent';
import WtContent from './sidebar-menu/WtContent';
import KrwContent from './sidebar-menu/KrwContent';

/**
 * class DwdfMenu TODO integrate it with StepList component later
 */
class SideBarMenu extends Component {

    componentDidMount() {
        window.$(`#step-${this.props.currentStep}`)
        .addClass('active current-step')
        .find('.circle')
        .addClass('current-circle')
        .children()
        .addClass('current-main-circle');
        if (this.props.currentStep === 1) {
            window.$('.above-first-step').addClass('select-above-first-step');
        } else {
            window.$('.above-first-step').removeClass('select-above-first-step');
        }
        // Set height and overflow for sidebar menu
        const divMenuContainer = window.$('.div-menu-col');
        if (divMenuContainer.outerHeight() + 1 < divMenuContainer.prop('scrollHeight')) {
            // with overflow
            window.$('.div-menu').css('height', 'auto');
            divMenuContainer.css('overflow', 'auto');

        } else {
            // without overflow
            window.$('.div-menu').css('height', '94%');
            divMenuContainer.css('overflow', 'hidden');
        }
    }

    componentDidUpdate() {
        window.$('.step-item').each(function() {
            window.$(this)
            .removeClass('active current-step');
        });
        window.$('.divider-element').each(function() {
            window.$(this).css('visibility', 'visible');
        });
        window.$('.divider-line').each(function() {
            window.$(this).css('visibility', 'visible');
        });
        window.$('.circle').each(function() {
            window.$(this)
            .removeClass('current-circle')
            .children()
            .removeClass('active-main-circle current-main-circle')
        });
        for (let i = 0; i <= this.props.currentStep; i++) {
            window.$(`#step-${i}`)
            .addClass('active')
            .find('.circle')
            .children()
            .addClass('active-main-circle');
        }
        window.$(`#step-${this.props.currentStep}`)
        .addClass('current-step')
        .find('.circle')
        .addClass('current-circle')
        .children()
        .addClass('current-main-circle');

        // hide divider
        const previousStep = this.props.currentStep > 1 ? this.props.currentStep - 1 : null;
        if (previousStep) {
            window.$(`#step-${previousStep}`)
            // .find('.divider-element')
            // .css('visibility', 'hidden')
            .find('.divider-line')
            .css('visibility','hidden');
        }
        if (this.props.currentStep === 1) {
            window.$('.above-first-step').addClass('select-above-first-step');
        } else {
            window.$('.above-first-step').removeClass('select-above-first-step');
        }
        if (this.props.currentStep === this.props.lastStep) {
            window.$('.below-last-step').addClass('select-below-last-step');
        } else {
            window.$('.below-last-step').removeClass('select-below-last-step');
        }
    }

    /**
     * handleStepName
     * @param number
     * @param names
     * @returns {string}
     */
    handleStepName(number, names) {
        const step = 'step';
        return `${step}${names[number]}`;
    }

    calculateSize(type) {
        if (type === 'lange') {
            if (parseInt(this.props.bathtub.VAR_ABM) === 0) {
                return (parseInt(this.props.bathtub.W_LAENGE.CurrentValue));
            } else {
                return (
                    parseInt(this.props.bathtub.W_LAENGE.CurrentValue) +
                    parseInt((this.props.bathtub.S081 || 0)) +
                    parseInt((this.props.bathtub.S045 || 0))
                );
            }
        }
        if (type === 'breite') {
            if (parseInt(this.props.bathtub.VAR_ABM) === 0) {
                return (parseInt(this.props.bathtub.W_BREITE.CurrentValue));
            } else {
                return (
                    parseInt(this.props.bathtub.W_BREITE.CurrentValue) +
                    parseInt((this.props.bathtub.S023 || 0)) +
                    parseInt((this.props.bathtub.S067 || 0))
                );
            }
        }
    }

    updateContent(stepName, index, arr) {
        let details = [];
        switch(stepName) {
            case 'One':
                Maybe.of(this.props.bathtub.W_BREITE.CurrentValue && this.props.bathtub.W_LAENGE.CurrentValue) 
                    .map(() => {
                        details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)} ${this.calculateSize('lange')} x ${this.calculateSize('breite')}`);
                    });
                Maybe.of(this.props.bathtub.BREITE.CurrentValue && this.props.bathtub.LAENGE.CurrentValue)
                    .map(() => {
                        details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.2`)} ${this.props.bathtub.LAENGE.CurrentValue} x ${this.props.bathtub.BREITE.CurrentValue}`);
                    });
                break;
            case 'Two':
                const ZT = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((field_value) => {
                            details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)} ${this.props.bathtub.ZT.CurrentValue}`);
                        })
                }

                let teilzarge = [];
                const TEILZARGE = (field, name) => {
                    return Maybe.of(this.props.bathtub[field])
                    .map((field) => {
                        return parseInt(field.CurrentValue);
                    })
                    .map((field_value) => {
                        teilzarge.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${name}`));
                    })
                }
                const getName = (field) => {
                    switch(field) {
                        case 'Z23':
                            return 'back';
                        case 'Z45':
                            return 'left';
                        case 'Z67':
                            return 'front';
                        case 'Z81':
                            return 'right';
                    }
                }

                ZT(this.props.bathtub.ZT);

                ['Z23', 'Z45', 'Z67', 'Z81'].forEach((field) => {
                    TEILZARGE(`${field}_activator`, getName(field))
                });
                details.push(teilzarge.length > 0  ? `${this.props.translate('BATHTUB.stepTwo.form.checkbox')}: ${teilzarge.join(', ')}` : '');
                break;        
            case 'Three':
                if (this.props.bathtub.EA12) {
                    if (parseInt(this.props.bathtub.EA12.CurrentValue) > 1  || parseInt(this.props.bathtub.EA34.CurrentValue) > 1 || parseInt(this.props.bathtub.EA56.CurrentValue) > 1 || parseInt(this.props.bathtub.EA78.CurrentValue) > 1 ) {
                        let definedElement = 0;
                        if (parseInt(this.props.bathtub.EA12.CurrentValue) > 1) {
                            definedElement++;
                        }  
                        if (parseInt(this.props.bathtub.EA34.CurrentValue) > 1) {
                            definedElement++;
                        } 
                        if (parseInt(this.props.bathtub.EA56.CurrentValue) > 1) {
                            definedElement++;
                        } 
                        if (parseInt(this.props.bathtub.EA78.CurrentValue) > 1 ) {
                            definedElement++;
                        }
                        details.push(`${definedElement} ${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.1`)}`);
                    }

                }
                break;
            case 'Four': 
                let name = '', pos;

                const lochType = () => {
                    return Maybe.of(this.props.bathtub.lochbohrungen_select.CurrentValue)
                        .map((value) => {
                            if (value === 'L1') {
                                name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.L1`);
                            } else if (value === 'L2') {
                                name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.L2`);
                            } else if (value === 'AT') {
                                name = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.AT`);
                                return 'ATP';
                            }
                            return value;
                        })
                        .map((value) => {
                            return position(value).join();
                        })
                }        
                const position = (value) => {
                    return Maybe.of(this.props.bathtub[value]).map((val) => {
                        pos = val.Values.Value.find((el) => { return parseInt(el.Code) === parseInt(this.props.bathtub[value].CurrentValue)}).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                        details.push(`${name} ${pos}`)
                        return true;
                    });
                }
                lochType()
                    .orElseFun(() => {
                        details.push(name);
                    });
                break;
            case 'Five':
                let splash = '', sp;
                const SP = () => {
                    return Maybe.of(parseInt(this.props.bathtub.SP.CurrentValue))
                    .map((SP_Value) => {
                        sp = this.props.bathtub.SP.Values.Value.find((el => parseInt(el.Code) === SP_Value)).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                        details.push(`${splash} ${sp}`);
                        return true;
                    })

                }
                const SPV = () => {
                    return Maybe.of(this.props.bathtub.SPV)
                        .map((SPV) => {
                            return parseInt(SPV.CurrentValue);
                        })
                        .map((SPV_Value) => {
                            splash = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.SPV`);
                            return splash;
                        })
                        .map((splash) => {
                            return SP()
                            .join()
                        })
                }

                SPV()
                .orElseFun(() => {
                    details.push(`${splash}`);
                })
                break;

            case 'Six':
                let gr = '', gft1, gfp1, content;

                const GFT1 = () => {
                    return Maybe.of(this.props.bathtub.GR)
                        .map((GR) => {
                            return parseInt(GR.CurrentValue);
                        })
                        .map((GR_Value) => {
                            gr = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.GR`);
                            return gr;
                        })
                        .map((gr) => {
                            return Maybe.of(parseInt(this.props.bathtub.GFT1.CurrentValue))
                                .map((GFT1_Value) => {
                                    gft1 = this.props.bathtub.GFT1.Values.Value.find((el) => { return parseInt(el.Code) === GFT1_Value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                                    return gft1;
                                })
                                .map((gft1) => {
                                    return GFP1(gft1)
                                        .orElseFun(() => {
                                            details.push(`${gr} ${gft1}`);
                                            return true;
                                        })
                                })
                                .join()
                        })
                }; 

                const GFP1 = () => {
                    return Maybe.of(this.props.bathtub.GFP1.CurrentValue)
                        .map((GFP1_Value) => {
                            gfp1 = this.props.bathtub.GFP1.Values.Value.find((el) => { return el.Code === GFP1_Value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                            details.push(`${gr} ${gft1} ${gfp1}`);
                            return true;
                        })
                        
                }

                GFT1()
                    .orElseFun(() => {
                        details.push(gr);
                    })

                break;
            case 'Seven':
                let whirlsystem, ws, alg;

                const WS = () => {
                    return Maybe.of(this.props.bathtub.MISSING_WHIRLSYSTEM)
                        .map((MISSING_WHIRLSYSTEM) => {
                            return parseInt(MISSING_WHIRLSYSTEM.CurrentValue);
                        })
                        .map((MISSING_WHIRLSYSTEM_Value) => {
                            whirlsystem = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.whirlsystem`);
                            return Maybe.of(parseInt(this.props.bathtub.WS.CurrentValue))
                                .map((ws_value) => {
                                    ws = this.props.bathtub.WS.Values.Value.find((el) => { return parseInt(el.Code) === ws_value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                                    return ALG(ws_value)
                                    .orElseFun(() => {
                                        details.push(`${whirlsystem} ${ws}`)
                                        return true;
                                    })
                                })
                                .join()
                        })
                }

                const ALG = (ws_value) => {
                    return Maybe.of(this.props.bathtub.ALG)
                        .map((alg) => {
                            return alg.CurrentValue;
                        })
                        .map((alg_value) => {
                            return _.isArray(this.props.bathtub.ALG.Values.Value);
                        })
                        .map((isArray) => {
                            if (this.props.bathtub.ALG.Values.Value.find((el) => { return el.Code === this.props.bathtub.ALG.CurrentValue})) {
                                alg = this.props.bathtub.ALG.Values.Value.find((el) => { return el.Code === this.props.bathtub.ALG.CurrentValue }).Description[`${setLanguageIndex(this.props.currentLanguage)}`]; 
                                details.push(`${whirlsystem} ${ws} ${alg}`);
                            }
                            return true;
                        })
                }

                WS()
                .orElseFun(() => {
                    details.push(whirlsystem);
                });
                break;

            case 'Eight':
                let soundsystem, model;
                const SOUNDSYSTEM = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue)
                        })
                        .map((field_value) => {
                            soundsystem = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.soundsystem`);
                            return MODEL(parseInt(this.props.bathtub.SOUNDSYSTEM.CurrentValue));
                        })
                }

                const MODEL = (sound) => {
                    return Maybe.of(sound)
                        .map((sound) => {
                            model = this.props.bathtub.SOUNDSYSTEM.Values.Value.find((el) => { return parseInt(el.Code) === sound }).Description[`${setLanguageIndex(this.props.currentLanguage)}`]
                            details.push(`${soundsystem} ${model}`);
                            return true;
                        })
                        .join();
                }

                SOUNDSYSTEM(this.props.bathtub.MISSING_SOUNDSYSTEM)
                    .orElseFun(() => {
                        details.push(soundsystem);
                    });

                break;
            case 'Nine':
                let checkboxContent = [];
                const FA = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue)
                        })
                        .map((fa_value) => {
                            details.push(this.props.bathtub.FA.Values.Value.find((el) => { return  parseInt(el.Code) === fa_value}).Description[`${setLanguageIndex(this.props.currentLanguage)}`]);
                        })
                }

                const ANTIGLISS = (field) => {
                    return Maybe.of(field)
                        .map((field) => {
                            return parseInt(field.CurrentValue);
                        })
                        .map((antigliss_value) => {
                             checkboxContent.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.antigliss`));
                        })
                }

                const GLASSUR = (field) => {
                    return Maybe.of(field)
                    .map((field) => {
                        return parseInt(field.CurrentValue);
                    })
                    .map((glassur_value) => {
                         checkboxContent.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.glassur`));
                    })
                }

                FA(this.props.bathtub.FA);
                ANTIGLISS(this.props.bathtub.GT);
                GLASSUR(this.props.bathtub.OV)
                details.push(checkboxContent.join(', '));

                break;
            default:
                return details;
        }
        return details;
    }

    /**
     * render Menu
     * @param step
     * @returns {XML}
     */
    renderMenu(arr) {
        let name, value = '';
        return arr.map((el, index) => {
            let details = [];
            if (index === arr.length - 1) {
                name = 'downloadAndContact.title';
            } else {
                // value = index === 0 ? `${this.calculateSize('lange')} x ${this.calculateSize('breite')}`: '';
                value=''
                name = `${this.props.field}.${this.handleStepName(index, arr)}.menu.title`;
                const detailsLength = this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.len`);
                details = this.updateContent(el, index, arr)
                // for(let i = 0; i < detailsLength; i++) {
                //     details.push(this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.${i+1}`));
                // }
            }
            return (
                <Step
                    key={index}
                    name={this.props.translate(name)}
                    value={value}
                    details={details}
                    currentStep={this.props.currentStep}
                    stepNo={index + 1} />

            );
        });
    }

    renderArticleMenu(stepList) {
        switch(this.props.field) {
            case 'BATHTUB':
                return <BathtubContent 
                    list={stepList} 
                    field={this.props.field} />
            case 'DWDF':
                return <DwdfContent 
                    list={stepList} 
                    field={this.props.field} />
            case 'WT':
                return <WtContent 
                    list={stepList} 
                    field={this.props.field} />
            case 'KRW':
                return <KrwContent
                    list={stepList}
                    field={this.props.field} />
        }
    }

    render() {
        return(
            <ul className='new-step-list'>
                {this.renderArticleMenu(this.props.stepList)}
            </ul>
        );
    }

};

/**
 * Prop types
 * @type {{translate: *, currentStep: *, stepList: *, field: *}}
 */
SideBarMenu.propTypes = {
    translate:   PropTypes.func.isRequired,
    currentStep: PropTypes.number,
    stepList:    PropTypes.array,
    field:       PropTypes.string,
    lastStep:    PropTypes.number,
    bathtub:     PropTypes.object,
};

/**
 * mapStateToProps
 * @param state
 * @returns {{numberOfSteps: (*|number), currentStep: (*|number), stepOne: (*|DWDF.stepOne|{menu, form}|Array), translate: (*|translations|{}|Translations|initialState.translations), currentLanguage: string}}
 */
const mapStateToProps = (state) => {
    return {
        numberOfSteps:   state.steps.numberOfSteps,
        currentStep:     state.steps.currentStep,
        stepOne:         state.stepOne,
        translate:       getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        bathtub:         state.bathtub,
    }
};

export default connect(mapStateToProps, actions)(SideBarMenu);







// WEBPACK FOOTER //
// ./src/components/SideBarMenu.js